module.exports = "<Button\n  buttonType=\"primary\"\n  size=\"medium\"\n>\n  Send This Playlist\n</Button>\n"